import c from "../common"
export default {
    // Main Page
    Related: "Related Events",
    LastEdit: "Last Edit",
    CreateDate: "Create Date",
    Choose: "Choose an event from the left",
    NoEvent: "No currently availabe Event",
    Joined: "Participated Vendors",
    VoucherNDiscount: c.voucher.en.uppercase + " & " + c.discount.en.uppercase,
    Estamp: c.estamp.en,
    EarnPeriod: "Earning Period until",
    EarnRate: "spent required per point",
    Event: c.event.en,

    // Status
    Pending: c.Pending.en,
    OnGoing: c.OnGoing.en,
    Expired: c.Expired.en,
    Cancelled: c.Cancelled.en,   
    WaitApprove: c.WaitApprove.en,

    // Common
    To: "To",
    NA: c.NA.en,
    NoDescription: "No Description",

    // Message

}